export { default as SearchIcon } from './Search'
export { default as RightIcon } from './Right'
export { default as FilterIcon } from './Filter'
export { default as ClockIcon } from './Clock'
export { default as AddIcon } from './Add'
export { default as BackIcon } from './Back'
export { default as ClearIcon } from './Clear'
export { default as CheckboxIcon } from './Checkbox'
export { default as StarIcon } from './Star'
export { default as CloseIcon } from './Close'
export { default as MinusIcon } from './Minus'
export { default as PlusIcon } from './Plus'
export { default as TrashIcon } from './Trash'
export { default as QuestionIcon } from './Question'
export { default as WaringIcon } from './Waring'
export { default as UploadIcon } from './Upload'
export { default as CheckedIcon } from './Checked'
export { default as NotificationIcon } from './Notification'
export { default as MenuIcon } from './MenuIcon'
export { default as Degree360Icon } from './360'
export { default as CrmTableIcon } from './CrmTable'
export { default as GoogleIcon } from './GoogleIcons'
export { default as DownIcon } from './Down'
export { default as HamburgerMenuIcon } from './HamburgerMenu'
export { default as UpIcon } from './UpIcon'
export { default as YoutubeGrayModeIcon } from './YoutubeGrayMode'
export { default as InstagramGrayModeIcon } from './InstagramGrayMode'
export { default as FacebookGrayModeIcon } from './FacebookGrayMode'
export { default as TelegramGrayModeIcon } from './TelegramGrayMode'
export { default as WhatsUpGrayModeIcon } from './WhatsUpGrayMode'
export { default as EditIcon } from './EditIcon'
export { default as BottomIcon } from './Bottom'

export { default as OrderClock } from './OrderClock'
export { default as DeliveredIcon } from './Delivered'
export { default as CourierIcon } from './Courier'
export { default as AcceptedIcon } from './AcceptedStatus'
export { default as NotPaymentIcon } from './NotPayment'

export { default as StatusFirst } from './Status_1'
export { default as StatusSecond } from './Status_2'
export { default as StatusThird } from './Status_3'
export { default as StatusFourth } from './Status_4'

export { default as SupportIcon } from './Support'
export { default as RepeatIcon } from './Repeat'
export { default as PhoneIcon } from './Phone'

export { default as LocationIcon } from './Location'
export { default as PencilIcon } from './Pencil'
export { default as KitchenDetailsIcon } from './Kitchen-details'
export { default as CallIcon } from './Call'
export { default as DeliveryAndPaymentIcon } from './DeliveryAndPayment'
export { default as InfoIcon } from './Info'
export { default as VacanciesIcon } from './Vacancies'
export { default as GlobeIcon } from './Globe'
export { default as DocumentIcon } from './Document'
export { default as PercentIcon } from './Percent'
export { default as NewsIcon } from './News'
export { default as GalleryIcon } from './Gallery'

export { default as InstagramIcon } from './Instagram'
export { default as TelegramIcon } from './Telegram'
export { default as YoutubeIcon } from './Youtube'
export { default as TikTokIcon } from './Tik-tok'
export { default as FacebookIcon } from './Facebook'

export { default as UzbIcon } from './Uzb'
export { default as RusIcon } from './Rus'
export { default as EngIcon } from './Eng'
export { default as KzhIcon } from './Kzh'
export { default as CutleryIcon } from './Cutlery'
